import {
  MakerIndexResponse,
  MakerWithCategoriesResponse,
} from "@/web-client/api";
import { FC } from "react";
import MakerMainVisual from "@/features/maker/components/MakerMainVisual";
import useMakerPage from "@/features/maker/hooks/useMakerPage";
import MakerIdentity from "@/features/maker/components/MakerIdentity";
import useDevice from "@/hooks/useDevice";

interface Props {
  maker: MakerIndexResponse | MakerWithCategoriesResponse;
}

const MakerIndexHeader: FC<Props> = ({ maker }): JSX.Element => {
  const { isPc } = useDevice();
  const { hasVisualImages } = useMakerPage(maker);

  // メインビジュアルがあれば、スライドショーイメージ
  if (maker && maker.is_contracted && hasVisualImages)
    return <MakerMainVisual maker={maker} />;

  // なければロゴもしくはメーカー名を表示するのみ
  return (
    <div className="flex justify-center laptop:pt-80 laptop:pb-16 pt-48 pb-48 px-32">
      <MakerIdentity maker={maker} logoMaxWidth={isPc ? 320 : 240} />
    </div>
  );
};
export default MakerIndexHeader;
